import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ApolloProvider } from "react-apollo";
import ApolloClient from "apollo-boost";
import { QueryClient, QueryClientProvider } from "react-query";
// Styles
// CoreUI Icons Set
// import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import "flag-icon-css/css/flag-icon.min.css";
// Import Font Awesome Icons Set
import "font-awesome/css/font-awesome.min.css";
// Import Simple Line Icons Set
import "simple-line-icons/css/simple-line-icons.css";
// Import Main styles for this application
import "./scss/style.css";
// SETENS global UI consistency layer (buttons, typography overrides)
import "./scss/setens-ui.css";

// Containers
import { DefaultLayout } from "./containers";
// Pages
import { Login, Privacy, Help } from "./views/Pages"; // Page404, Page500, Register

// import LogRocket from "logrocket";
// LogRocket.init("8bz1s3/setens");
// if (localStorage.getItem("email")) {
//   LogRocket.identify(localStorage.getItem("email"), { email: localStorage.getItem("email") });
// }

const queryClient = new QueryClient();

const client = new ApolloClient({
  uri: "https://sera-server.herokuapp.com",
  request: async (operation) => {
    const token = await localStorage.getItem("token");
    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}` : "",
      },
    });
  },
});

// import { renderRoutes } from 'react-router-config';

class App extends Component {
  render() {
    return (
      <QueryClientProvider client={queryClient}>
        <ApolloProvider client={client}>
          <Router>
            <Switch>
              <Route exact path="/login" name="Login Page" component={Login} />
              <Route exact path="/privacy" name="Privacy Policy" component={Privacy} />
              <Route exact path="/help" name="Help" component={Help} />
              Help
              <Route path="/" name="Home" component={DefaultLayout} />
            </Switch>
          </Router>
        </ApolloProvider>
      </QueryClientProvider>
    );
  }
}

export default App;
